import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class IncidentReportService {
  static getIncidentTypeList() {
    return HttpUtil.get(API_ROUTES.INCIDENTREPORT.LIST);
  }

  static onSubmit(id, params) {
    var url = API_ROUTES.INCIDENTTYPES.SUBMIT;
    if (id != null && id !== "") {
      url += "/" + id;
      return HttpUtil.put(url, params);
    } else {
      return HttpUtil.post(url, params);
    }
  }
  static reportIncident(params) {
    return HttpUtil.post(API_ROUTES.INCIDENTREPORT.REPORTINCIDENT, params);
  }  

  //   static deleteData(encodedUrlParam,id) {
  //     var url = API_ROUTES.COUNTRYSCORE.DELETE.replace("<encodedUrlParam>", encodedUrlParam)
  //     .replace("<id>", id);
  //     return HttpUtil.delete(url);
  //   }
  static getIncidentDetails(id) {
    return HttpUtil.get(
      API_ROUTES.INCIDENTREPORT.GETINCIDENT.replace("<id>", id)
    );
  }
  static updateIncidentStatus(id, status) {
    return HttpUtil.patch(
      API_ROUTES.INCIDENTREPORT.UPDATESTATUS.replace("<id>", id).replace(
        "<status>",
        status
      )
    );
  }
  static updateAssignee(id, user) {
    return HttpUtil.patch(
      API_ROUTES.INCIDENTREPORT.ASSIGNINCIDENT.replace("<id>", id).replace(
        "<user>",
        user
      )
    );
  }
  static getIncidentActivityLogs(id) {
    return HttpUtil.get(
      API_ROUTES.INCIDENTREPORT.GETINCIDENTACTIVITYLOGS.replace("<id>", id)
    );
  }
  static createComment(params, id) {
    return HttpUtil.post(
      API_ROUTES.INCIDENTREPORT.CREATECOMMENT.replace("<id>", id),
      params
    );
  }
  static updateincident(id, payload) {
    return HttpUtil.put(
      API_ROUTES.INCIDENTREPORT.UPDATE_INCIDENT.replace("<id>", id),
      payload
    );
  }
}
